export default __webpack_public_path__ + "static/media/logo.5767bf81.svg";